import { render, staticRenderFns } from "./ComponentRefundExchangeFee.vue?vue&type=template&id=094440b1&"
import script from "./ComponentRefundExchangeFee.vue?vue&type=script&lang=ts&"
export * from "./ComponentRefundExchangeFee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports